const headers = {
  name: "Profit & Loss",
  components: [
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
  ],
  navigate: {
    tabs: [
      {
        name: "General Ledger",
        path: "/app/common/reports",
      },
      {
        name: "Trial Balance",
        path: "/app/common/reports/trail-balance",
      },
      {
        name: "Balance Sheet",
        path: "/app/common/reports/balance-sheet",
      },
      {
        name: "Profit & Loss",
        path: "",
      },
        {
        name: "AR Report",
        path: "/app/common/reports/ar-report",
      },
      {
        name: "AP Report",
        path: "/app/common/reports/ap-report",
      },
    ],
    total: [
      { value: 0, label: "Total Income" },
      { value: 0, label: "Total Expenses" },
      { value: 0, label: "Net Profit" },
    ],
  },
};

export default headers;
